// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  max-height: calc(100vh - 20rem);
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 14rem;
}

.sub-title {
  font-size: 1.4rem;
  font-weight: bold;
}

.notes-area {
  font-size: 0.9rem;
  padding: 0.4rem;
  min-height: 8rem;
  margin-right: 0.3rem;
  height: 126px;
}

.warning {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/filming-global-modal/filming-global-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":[".form-container {\n  max-height: calc(100vh - 20rem);\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 14rem;\n}\n\n.sub-title {\n  font-size: 1.4rem;\n  font-weight: bold;\n};\n\n.notes-area {\n  font-size: 0.9rem;\n  padding: 0.4rem;\n  min-height: 8rem;\n  margin-right: 0.3rem;\n  height: 126px;\n}\n\n.warning {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
